// CommitChart.js

import { TweenMax, TweenLite, Power3, ScrollToPlugin } from 'gsap/all'
import 'gsap/ScrollToPlugin'
const plugins = [ ScrollToPlugin];

import {Line} from 'vue-chartjs'
import GraphManager from '../../../../helpers/GraphManager'
import config from '../../../../config'
import MedicationRegimeLocalizerMixin from '../../../../mixins/Localization/MedicationRegimes'
import WeightApi from "../../../../api/Tracking/Weight";
let fromDate = moment().locale(config.language).startOf('month');
let toDate = moment().locale(config.language).endOf('month');

import store from "../../../../store";

export default {

  extends: Line,
  mixins:[MedicationRegimeLocalizerMixin],
  props: {
    showPoints: false,
    type: {
      type: String,
    },
    dateStep: 0,
    userId: 0,
    medTrackingId: 0,
    activeStepsType: '',
    activeSleepType: '',
    fromDate: {
      type: String,
      default: fromDate.format('YYYY-MM-DD')
    },
    toDate: {
      type: String,
      default: toDate.format('YYYY-MM-DD')
    }
  },
  watch: {
    'userId': function () {
      let self = this;
      self.loadData();
    },
    'fromDate': function () {
      let self = this;
      self.loadData();
    },
    'toDate': function() {
      let self = this;
      self.loadData();
    },
    'medTrackingId': function () {
      let self = this;
      self.loadData();
    },
    'activeStepsType': function () {
      let self = this;
      self.loadData();
    },
    'activeSleepType': function () {
      let self = this;
      self.loadData();
    },
    'showPoints': function () {
      let self = this;
      if (self.showPoints === true) {
        if (self.$data._chart) {
          self.$data._chart.options.elements.point.radius = 4;
          self.$data._chart.update({duration: 1000});
        }
      }
      else {
        if (self.$data._chart) {
          self.$data._chart.options.elements.point.radius = 0;
          self.$data._chart.update({duration: 1000});
        }
      }
    }
  },
  name: 'line-graph',
  data: function data() {
    return {
      chartData: null,
      series: [],
      data: [],
      Labels: [],
      override: [],
      dataset: [],
      options: {
        elements: {point: {radius: 0}},
        animation: {
          duration: 0,
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 16,
            bottom: 16
          }
        },
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  mounted: function mounted() {
    let self = this;
    const mainContentElement = document.getElementsByClassName('main-content')[0];
    self.loadData();

    if (self.showPoints === true) {
      self.options.elements.point.radius = 4;
    }
    self.$EventBus.$on('showGraphPoints', function () {
      if (_.has(self.$data._chart, 'options')) {
        self.$data._chart.options.elements.point.radius = 4;
        self.$data._chart.update();
      }
    });

    self.$EventBus.$on('hideGraphPoints', function () {
      if (self.$data._chart !== undefined) {
        self.$data._chart.options.elements.point.radius = 0;
        self.$data._chart.update();
      }
    });

    self.$EventBus.$on('updateGraphData', function () {
      self.loadData();
    });
    self.$EventBus.$on('updateGraph', function () {
      TweenLite.to(mainContentElement, 0.2, {scrollTo: 0});
      self.loadData();
    })
  },
  methods: {
    loadData: function loadData() {
      let self = this;
      self.$emit('graphLoading', true);
      GraphManager.handleGraphType(self)
    },
    renderChartFromData: function (response) {
      let self = this;
      self.data = response.data.data;
      self.labels = response.data.labels;
      self.series = response.data.series;
      self.override = response.data.override;


      if (self.series.length === 1) {
        self.options.elements.point.radius = 4;
      }


      self.dataset = [];
      let timeUnit;
      timeUnit = "day";
      if (self.dateStep === 1 || self.dateStep === 0) {
        timeUnit = "hour"
      }
      if (self.dateStep === 7) {
        timeUnit = "day";
      }
      if (self.dateStep === 30) {
        timeUnit = "day"
      }
      if (self.dateStep === 360) {
        timeUnit = "month"
      }


      self.options.legend = {
        display: false,
        labels: {
          fontColor: "#767576",
          fontSize: 14,
          usePointStyle: true,
          padding: 16
        }
      };
      const type = self.type;


      self.options.tooltips = {
        mode: "nearest",
        cornerRadius: 5,
        callbacks: {
          title: function (tooltipItem) {
            return moment(tooltipItem[0].xLabel).format("DD-MM-YYYY HH:mm a");
          },
          label: function (tooltipItem, data) {
            let label = data.datasets[tooltipItem.datasetIndex].label;
            let value = tooltipItem.yLabel;

            if (label === "Stones & Pounds") {
              let pounds = Math.round(value * 14);
              let stones = parseInt(pounds * 0.071429);
              let remainder = pounds % 14;
              let poundsUnit;
              (pounds > 0) ? poundsUnit = "lbs" : poundsUnit = "lb";
              return stones + "st " + (pounds = remainder) + poundsUnit
            }


            if(label === 'minutesAsleep' || label === 'minutesAwake' || label === 'stageRemMinutes' || label === 'stageDeepMinutes' || label === 'stageLightMinutes') {

              if(value >= 60) {
                let hours = Math.floor(value / 60);
                let minutes = value % 60;
                return moment.duration(hours, 'hours').format('h _') + ' ' + moment.duration(minutes, 'minutes').format('m _');


              }
              else {
                return moment.duration(value, 'minutes').format('m _');
              }


            }


            if(label === 'Pounds') {
              return value + ' lbs';
            }

            if(label === 'Kilograms') {
              return value + ' kg';
            }

            if  (label === 'ratio') {
              let waistData = response.data['waist-hip'][tooltipItem.index];
              let waistRatio = 'Waist-hip ratio: ' + value;
              let waistInfo;
              let weightArr = [waistRatio];
              if (store.state.user.settings.waist.measure === 'cm') {
                 waistInfo = 'Waist: ' + waistData.waist_cm + 'cm Hip: ' +  waistData.hip_cm + 'cm';
              } else if (store.state.user.settings.waist.measure === 'in') {
                 waistInfo = 'Waist: ' + waistData.waist_in + 'in Hip: ' +  waistData.hip_in + 'in';
              }
              weightArr.push(waistInfo)
              return weightArr;
              //return waistRatio + "\n <br />" + waistInfo;
            }

            if (label === 'Calories Burnt') {
              return value + 'kcal';
            }
            if (label === 'Systolic (mmHg)') {
              return value + ' ' + self.$t('message.labelSystolic') + ' (mmHg)';
            }
            if (label === 'Diastolic (mmHg)') {
              return value + ' ' + self.$t('message.labelDiastolic') + ' (mmHg)';
            }

            if(label === 'Basal') {
              return value + ' ' +  self.$t('message.labelBasal');
            }

            if(label === 'Bolus') {
              return value + ' ' + self.$t('message.labelBolus');
            }

            if(label === 'Correction') {
              return value + ' ' + self.$t('message.labelCorrection');
            }

            if(label === 'Lower ketone range' || label === 'Upper range') {
              return value + ' ' + self.$t('message.labelUpperRange');
            }

            if(label === 'Upper ketone range' || label === 'Lower range') {
              return value + ' ' +  self.$t('message.labelLowerRange')
            }

            if(self.type === 'medication') {
              return value + ' ' + self.$t(self.localizeRegime(label));
            }

            if(self.type === 'mood') {
              if(label === 'Mood') {
                return value + ' ' + self.$t('message.cardMood')
              }
              else {
                return value + ' ' + self.$t('message.labelBaseLine');
              }
            }

            else return tooltipItem.yLabel + ' ' + data.datasets[tooltipItem.datasetIndex].label
          }
        },
        displayColors: false,
        xPadding: 16,
        yPadding: 16,
        titleFontFamily: "Poppins",
        titleFontStyle: "200",
        bodyFontFamily: "Poppins",
        backgroundColor: "#0179d5",
        titleFontSize: 16,
        titleFontColor: "white",
        bodyFontColor: "white",
        bodyFontSize: 14,
        intersect: false
      };
      self.options.scales = {
        yAxes: [{
          display: true,
          ticks: {
            autoSkip: true,
            autoSkipPadding: 16,
            fontFamily: "Poppins",
            fontColor: "#767576",
            fontSize: 14,
            beginAtZero: false,
            maxRotation: 0,
            minRotation: 0
          },
          gridLines: {
            display: true,
            color: "#738F9A",
            zeroLineColor: "transparent",
            borderDash: [1, 10],
            drawBorder: false
          }
        }],
        xAxes: [{
          weight: 10,
          display: true,
          type: 'time',
          distribution: 'linear',
          time: {
            unit: timeUnit,
            stepSize: 2,
            source: 'auto'
          },
          ticks: {
            autoSkip: true,
            autoSkipPadding: 16,
            fontFamily: "Poppins",
            fontColor: "#767576",
            fontSize: 14,
            stepSize: 5,
            beginAtZero: false,
            zeroLineColor: "transparent",
            showXAxisLabel: false,
            maxRotation: 0,
            minRotation: 0
          },
          gridLines: {
            display: true,
            color: '#738F9A',
            zeroLineColor: "transparent",
            borderDash: [1, 10],
            drawBorder: true
          }
        }]
      };
      if (self.type === "blood-glucose" || self.type === "ketones" || self.type === "cholesterol" || self.type === "sleep") {
        self.options.scales.xAxes[0].ticks.beginAtZero = true;
        self.options.scales.yAxes[0].ticks.beginAtZero = true;
      }
      const dataLength = self.data.length;
      for (let i = 0; i < dataLength; i++) {
        let Gradient = undefined, LineColor = undefined, PointColor = undefined;
        Gradient = GraphManager.graphColorGradientsByType(self, i);
        LineColor = GraphManager.graphLineColorByType(self, i);
        PointColor = GraphManager.graphLineColorByType(self, i);


        self.dataset.push({
          fill: true,
          spanGaps: true,
          label: self.series[i],
          data: self.data[i],
          backgroundColor: Gradient !== undefined ? Gradient : 'transparent',
          borderColor: LineColor !== undefined ? LineColor : self.override[i].borderColor,
          pointBackgroundColor: PointColor,
          pointBorderColor: PointColor,
          borderWidth: self.override[i].borderWidth,
          borderDash: self.type === "hba1c" ? [0, 0] : self.override[i].borderDash,
        });
      }
      self.dataset.reverse();
      const labelLength = self.labels.length;
      for (let i = 0; i < labelLength; i++) {
        self.labels[i] = self.labels[i]
      }
      if (self.chartData !== null) {
        const scrollingElement = $('.main-content');
        const previousPagePosition = scrollingElement.scrollTop();
        self.chartData.labels = self.labels;
        self.chartData.datasets = self.dataset;
        if (self.$data._chart) {
          self.$data._chart.options.scales.xAxes[0].time.unit = timeUnit;
          self.$data._chart.update({duration: 1000});
          scrollingElement.scrollTop(previousPagePosition);
        }
      }
      else {
        self.chartData = {
          labels: self.labels,
          datasets: self.dataset
        };
        self.renderChart(self.chartData, self.options);
      }

      self.$emit('graphLoading', false);
      self.$emit('graphLoaded', response)
    },
    beforeDestroy: function () {
      this.$EventBus.$off("updateGraph");
      this.$EventBus.$off("updateGraphData");
      this.$EventBus.$off("showGraphPoints");
      this.$EventBus.$off("hideGraphPoints")
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Tracking/Graph/Line/index.js